import React, { useEffect } from 'react';
import ProductImage from "../product/ProductImage";
import * as Icon from "@phosphor-icons/react";

export default function Product(props) {

    const { product } = props;
    

    return (
        <div className="product-tile" key={product?.id}>                      
            <div className="img-box" onClick={()=>window.location.href=`/product/${product.slug}`}>
                {Math.round(((product?.display_price - product.original_price) / product?.display_price) * 100) > 0 &&<div className="product-tag">
                    <span className="child1 yellow">New</span>
                    <span className="child2 redtwo">{`${Math.round(((product?.display_price - product?.original_price) / product?.display_price) * 100)} % OFF `}</span>
                </div>}
                
                {/* <img src={product.image} alt={product.name} /> */}
                <ProductImage name={product?.name} images={product?.thumb_images?.length>0 ? product.thumb_images:[product.primary_image]} thumbImage={product?.primary_image ? product.primary_image: ""} anmStyle="fade" />
                    
                {!props.isSimilar && <div className="product-btn">
                    <button className="button blur-bg">
                        BUY NOW
                    </button>
                </div>}
            </div>
            <div className="title">
                {product.name}
            </div>
            <div className="price d-flex justify-content-between">
                <span>
                    <span className="current-price">₹{product?.display_price?.toFixed(2)}</span>
                    <del className="discounted-price">₹{product?.original_price?.toFixed(2)}</del>
                </span>
                
                
                
            </div>
        </div>
    );
}